import React from "react";
import Money from "components/money";
import { useSelector } from "react-redux";
import { findClosestBox } from "utils/cart";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const ProductPrices = ({ variant, requireLoginToBuy, className, hideFreeLabel = false }) => {
	const { activeBox } = useSelector((state) => state.cart);
	const { totalWeight } = useSelector(state => state.account.subscription);
	const { isAuthenticated } = useSelector((state) => state.account.profile);
	const { translation, cartSettings, isSubscriptionPage } = useGlobalContext();

	if (!isAuthenticated && requireLoginToBuy) return <></>;

	let price = variant?.discountedPrice ?? variant?.price;
	let compareAtPrice = variant?.compareAtPrice;
	const isFree = price === 0;

	if (variant?.weight >= 1) {
		if (isSubscriptionPage && totalWeight > 0) {
			const box = findClosestBox(cartSettings.boxes, totalWeight);
			const boxDiscount = box.discount * variant.weight;
			if (!variant?.discountedPrice)
				price -= boxDiscount;
			compareAtPrice -= boxDiscount;
		}

		if (activeBox && !isSubscriptionPage) {
			const activeBoxDiscount = activeBox.discount * variant.weight;
			price -= activeBoxDiscount;
			compareAtPrice -= activeBoxDiscount;
		}
	}

	const discount = +(compareAtPrice - price).toFixed(2);

	return (
		<div className="text-center flex justify-center">
			{isFree && !hideFreeLabel ?
				<p className="text-xs bg-[#97AB51] w-max rounded-xl px-3 py-1">
					{translation?.product?.freeGift}
				</p> :
				<>
					<span className={className}><Money value={price} /></span>
					{discount > 0 &&
						<span className={clsx(className, "line-through ml-2 !text-secondary")}
							aria-label={`Original price: ${compareAtPrice}`} role="text">
							<Money value={compareAtPrice} />
						</span>}
				</>
			}
		</div>
	);
};


export default ProductPrices;